import Index from '@/views/exhibitor/item/Index.vue';
import Top from '@/views/exhibitor/item/Top.vue';
import New from '@/views/exhibitor/item/New.vue';
import Edit from '@/views/exhibitor/item/Edit.vue';
import Copy from '@/views/exhibitor/item/Copy.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'item',
    component: Index,
    children: [
      {
        name: 'exhibitor-item-top',
        path: '',
        component: Top,
        meta: {
          title: '商品一覧',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-item-new',
        path: 'new',
        component: New,
        meta: {
          title: '新規追加',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-item-copy',
        path: 'copy',
        component: Copy,
        meta: {
          title: '商品コピー',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      {
        name: 'exhibitor-item-edit',
        path: 'edit',
        component: Edit,
        meta: {
          title: '商品編集',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
      // {
      //   name: 'exhibitor-item-new-settings',
      //   path: 'new/settings',
      //   component: GItemSettingForm,
      // },
      // {
      //   name: 'exhibitor-item-new-image',
      //   path: 'new/images',
      //   component: GItemImageForm,
      // },
      // {
      //   name: 'exhibitor-item-new-sku',
      //   path: 'new/sku',
      //   component: GItemSkuForm,
      // },
      // {
      //   name: 'exhibitor-item-new-story',
      //   path: 'new/story',
      //   component: GItemStoryForm,
      // },
      // {
      //   name: 'exhibitor-item-edit-settings',
      //   path: 'edit/settings/:id',
      //   component: GItemSettingForm,
      // },
      // {
      //   name: 'exhibitor-item-edit-image',
      //   path: 'edit/images/:id',
      //   component: GItemImageForm,
      // },
      // {
      //   name: 'exhibitor-item-edit-sku',
      //   path: 'edit/sku/:id',
      //   component: GItemSkuForm,
      // },
      // {
      //   name: 'exhibitor-item-edit-story',
      //   path: 'edit/story/:id',
      //   component: GItemStoryForm,
      // },
    ],
  },
];

export default {
  routes,
};
